import React, { useState, useEffect,useRef } from "react";
import {
  Box,
  HStack,
  VStack,
  Text,
  Center,
  ScrollView,
  Button,
  useToast,
  Stack,
  FlatList,
  FormControl,
  Avatar,
  Input,
  Icon,
  IconButton,
  StatusBar,
  Heading,
  Select,
  Spacer,
  Tooltip,
  Image,
  Menu,
  Divider,
  Spinner,
  Modal,
  Checkbox,
  ChevronUpIcon,
} from "native-base";

import { GlobalStyles } from "../../constants/styles";
import TicksView from "../../components/TicksView";
import { GlobalConstants } from "../../constants/constants";
import { useNavigation,useRoute } from "@react-navigation/native";
import Toast from "../../components/Toast";
import { useSelector ,useDispatch} from "react-redux";
import axios from "axios";
import { Ionicons, MaterialIcons } from "@expo/vector-icons";
import { Pressable } from "react-native";
import LoadFonts from "../../components/LoadFonts";
import FeedCardForCitizen from "../../components/FeedCardForCitizen";
import AdCardForCitizen from "../../components/AdCardForCitizen.js";
import AdProductCardForBusiness from "../../components/AdProductCardForBusiness";
import { StyleSheet } from "react-native";
import SetUser from "../../redux/user/SetUser";
import { validEmail } from "../../utils/general";
import { flushSync } from 'react-dom';
//import for business services
import BusinessSurvey from "../../components/BusinessServices/CitizenSurvey";
import TicketManager from "../../components/BusinessServices/CitizenTicket";
import CouponManager from "../../components/BusinessServices/CitizenCoupon";
import BusinessReservation from "../../components/BusinessServices/CitizenReservation";
import LoyaltyManager from "../../components/BusinessServices/CitizenLoyalty";

const BusinessProfile = () => {
  const dispatch = useDispatch();
  // let user = useSelector((state) => state.user.user);
  let user = useSelector((state) => state.user.user);
  axios.defaults.headers.common = {
    Authorization: `bearer ${user ? user.token : null}`,
  };

  const toast = useToast();
  const { params } = useRoute();
  const navigation = useNavigation();
  const [cityGovBtnTextColor, setCityGovBtnTextColor] = useState(
    GlobalStyles.colors.white
  );

  const [businessBtnTextColor, setBusinessBtnTextColor] = useState(
    GlobalStyles.colors.white
  );

  const [eventsBtnTextColor, setEventsBtnTextColor] = useState(
    GlobalStyles.colors.white
  );

  const [openingsBtnTextColor, setOpeningsBtnTextColor] = useState(
    GlobalStyles.colors.white
  );

  const [dealsBtnTextColor, setDealsBtnTextColor] = useState(
    GlobalStyles.colors.white
  );

  const [adsBtnTextColor, setAdsBtnTextColor] = useState(
    GlobalStyles.colors.white
  );
  const [productsBtnTextColor, setProductsBtnTextColor] = useState(
    GlobalStyles.colors.white
  );

  const [savedBtnTextColor, setSavedBtnTextColor] = useState(
    GlobalStyles.colors.white
  );
  const [sharedBtnTextColor, setSharedBtnTextColor] = useState(
    GlobalStyles.colors.white
  );

  const [ticks, setTicks] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isLoadMoreLoading, setIsLoadMoreLoading] = useState(true);

  const [isEventsEnabled, setIsEventsEnabled] = useState(true);
  const [isOpeningsEnabled, setIsOpeningsEnabled] = useState(true);
  const [isDealsEnabled, setIsDealsEnabled] = useState(true);

  const [isShowEventsText, setIsShowEventsText] = useState(false);

  const [selectedPost, setSelectedPost] = useState({});
  const [data, setData] = useState({});
  const [feedType, setFeedType] = useState(0);
  const [friends, setFriends] = useState([]);
  const [showLoadMore, setShowLoadMore] = useState(true);
  const [page, setPage] = useState();
  const [isSavedFeeds, setIsSavedFeeds] = useState(false);
  const [isShareFeeds, setIsShareFeeds] = useState(false);
 
  const initialRef = useRef(null);
  const finalRef = useRef(null);
  const [activeButton, setActiveButton] = useState("");
  const [subActiveButton, setSubActiveButton] = useState("");
  const [topActiveButton, setTopActiveButton] = useState("");
  ///// Search and Follow Business////////////
  const [noSearchBusinessResultText, setNoSearchBusinessResultText] =
  useState("");
  const [unfollowBusinesses, setUnfollowBusinesses] = useState([]);
  const [businessSelectedId, setBusinessSelectedId] = useState();
  const [followedBusinesses, setFollowedBusinesses] = useState([]);
  const [isFollowedBusinessSelected, setIsFollowedBusinessSelected] =
    useState(false);
  const [isSearching, setIsSearching] = useState(false);
  const [isDropdownFilter, setIsDropdownFilter] = useState(false);

  const [businessCategories, setBusinessCategories] = useState([]);
  const [businessSubCategories, setBusinessSubCategories] = useState([]);
  // const [selectedSubCategoryId, setSelectedSubCategoryId] = useState(0);

  const [selectedCategory, setSelectedCategories] = useState("");
  const [selectedSubCategory, setSelectedSubCategories] = useState("");  
  const [isShowInvite, setIsShowInvite] = useState(false); 
  const [isShowProducts, setIsShowProducts] = useState(false); 
  const [inviteEmail, setInviteEmail] = useState("");
  const [isInviteSending, setIsInviteSending] = useState(false);
  const [invitedFriends, setInvitedFriends] = useState([]);
  /// Ads states ////////
  const [isAdsEnable, setIsAdsEnable] = useState(false);
  const [selectedIndexAd, setSelectedIndexAd] = useState(0);
  const [adType, setAdType] = useState(0);
  const [adsCat, setAdsCat] = useState([]);
  const isAdsEnableRef = useRef(isAdsEnable);
  const [isBrand, setIsBrand] = useState("LOCAL");
  const [categoryKey, setCategoryKey] = useState("category");
 const [subCategoryKey, setSubCategoryKey] = useState("sub-category");
 const [shareCount, setShareCount] = useState();
 /// for data show from start ///
 const [categories, setCategories] = useState([]); // list of category names
const [subCategories, setSubCategories] = useState([]); // current subcategories
const [selectedCategoryCheck, setSelectedCategoryCheck] = useState(null); // selected category
const [selectedSubCategoriesCheck, setSelectedSubCategoriesCheck] = useState([]); // selected subcategories
const [selectedCombinations, setSelectedCombinations] = useState([]); // category-subcategory combinations
const [fullCategoriesData, setFullCategoriesData] = useState([]);
const [productPosts,setProductPosts]=useState([]);
const [hasMorePosts, setHasMorePosts] = useState(true);
const [isProductView, setIsProductView] = useState(false);
const [currentPage, setCurrentPage] = useState(1);
const [isLoadingMore, setIsLoadingMore] = useState(false);
const [activeTab, setActiveTab] = useState("settings");
// CHANGE 1: Added activeService state to track which service menu item is selected
  const [activeService, setActiveService] = useState(null);
  const windowWidth = window?.innerWidth || 400;

 const [showSelects, setShowSelects] = useState(true); // optional
  const menuItems = [
    { name: "Loyality Points", icon: require("../../../assets/side-bar-icons/loyality.png"), action: () => setActiveService("loyalty")   },
    { name: "Coupons", icon: require("../../../assets/side-bar-icons/coupon_icon.png"), action: () => setActiveService("coupon") },
    { name: "Reservations", icon: require("../../../assets/side-bar-icons/reservation_icon.png"),  action: () => setActiveService("reservation") },
    { name: "Ticketing", icon: require("../../../assets/side-bar-icons/ticket_icon.png"), action: () => setActiveService("ticket") },
    { name: "Survey", icon: require("../../../assets/side-bar-icons/wpf_survey.png"), action: () => setActiveService("survey") },

  ];
  const scrollViewRef = useRef(null);
  const [showUpButton, setShowUpButton] = useState(false);
  const styles = StyleSheet.create({
    textWithShadow: {
      fontSize: 30,
      color: GlobalStyles.colors.mustard,
      fontFamily: GlobalStyles.text.fontFamily,
      textShadowColor: "#585858",
      textShadowOffset: { width: 1, height: 1 },
      textShadowRadius: 0,
    },
    textWithShadowMobile: {
      fontSize: 15,
      color: GlobalStyles.colors.mustard,
      fontFamily: GlobalStyles.text.fontFamily,
      textShadowColor: "#585858",
      textShadowOffset: { width: 1, height: 1 },
      textShadowRadius: 0,
    },
  });
  const scrollToTop = () => {
    if (scrollViewRef.current) {
      scrollViewRef.current.scrollTo({ y: 0, animated: true });
    }
  };
  const handleScroll = (event) => {
    const scrollY = event.nativeEvent.contentOffset.y;
    setShowUpButton(scrollY > 100); // Show button when user scrolls down 100px
  };
  const getData = () =>{
    console.log("data fetch")
  };
  const handlePress = (name, action) => {
    // setActive(name); 
    console.log(name,"print")
    action(); // Execute the dynamic function
  };

  // CHANGE 3:added renderActiveService function to render the correct component based on activeService state
  const renderActiveService = () => {
    const businessName = data?.name || "";
    const bId = params?.payload?.businessId;
    switch (activeService) {
      case "loyalty": return <LoyaltyManager businessName={businessName} businessId={bId} />;
      case "coupon": return <CouponManager businessName={businessName} businessId={bId} />;
      case "reservation": return <BusinessReservation businessName={businessName} businessId={bId} />;
      case "ticket": return <TicketManager businessName={businessName} businessId={bId} />;
      case "survey": return <BusinessSurvey businessName={businessName} businessId={bId} />;
      default: return null;
    }
  };
  const loadBusinessProfile = async (businessId, pageNo) => {
    if (isLoading || !isLoadMoreLoading) return;

  try {
    setIsLoading(true);
    console.log("data enter",data)
    const res = await axios.get(
      `${GlobalConstants.townTicksBaseUrl}businesses/${businessId}?page=${pageNo}`
    );

    const newItems = res.data?.data || [];
    console.log("data enter",newItems)
    setTicks(prev =>
      pageNo === 1 ? newItems : [...prev, ...newItems]
    );

    // If API returns empty → no more pages
    if (newItems.length === 10) {
      setIsLoadMoreLoading(false);
      setShowLoadMore(true);
    }
    else {
        setShowLoadMore(false);
    }
  } catch (err) {
    console.log("Pagination API error:", err);
  } finally {
    setIsLoading(false);
  }
  };
  const loadMoreFeed = () => {
    if (!isLoading && isLoadMoreLoading) {
      const nextPage = page + 1;
      setPage(nextPage);
      loadBusinessProfile(params.payload.businessId, nextPage);
    }
  };
  const onClick = async (data) => {
    console.log(data);
    setSelectedPost(data);
    if (data.is_saved) {
      await unSavePost(data.id);
    } else {
      await savePost(data.id);
    }
    // if (savedBtnTextColor == GlobalStyles.colors.mustard) {
    //   await getSavedPost(false);
    // }
  };
  const savePost = async (postId) => {
    try {
      const resp = await axios.post(
        `${GlobalConstants.townTicksBaseUrl}posts/save`,
        {
          post_id: postId,
        }
      );
      if (resp.data.status) {
        toast.show({
          render: () => {
            return (
              <Toast
                color={GlobalStyles.colors.green}
                message={"Post saved successfully!!!"}
              />
            );
          },
          placement: "top",
        });
      } else {
        toast.show({
          render: () => {
            return (
              <Toast
                color={GlobalStyles.colors.red}
                message={"Failed to save post!!!"}
              />
            );
          },
          placement: "top",
        });
      }
    } catch (error) {
      console.log(error);
    }
  };

  const unSavePost = async (postId) => {
    try {
      const resp = await axios.post(
        `${GlobalConstants.townTicksBaseUrl}posts/unsave`,
        {
          post_id: postId,
        }
      );
      if (resp.data.status) {
        toast.show({
          render: () => {
            return (
              <Toast
                color={GlobalStyles.colors.green}
                message={"Post unsaved successfully!!!"}
              />
            );
          },
          placement: "top",
        });
      } else {
        toast.show({
          render: () => {
            return (
              <Toast
                color={GlobalStyles.colors.red}
                message={"Failed to unsave post!!!"}
              />
            );
          },
          placement: "top",
        });
      }
    } catch (error) {
      console.log(error);
    }
  };
 
  function getAvatarChar(fullName) {
    let nameShortCode = "";
    if (fullName && fullName.split(" ").length > 1) {
      nameShortCode =
        fullName.split(" ")[0].charAt(0).toUpperCase() +
        fullName.split(" ")[1].charAt(0).toUpperCase();
    } else {
      nameShortCode = fullName.charAt(0).toUpperCase();
    }
    return nameShortCode;
  }

  useEffect(() => {
    if (!params) return;

    const { action, payload } = params;

    switch (action) {
      case "OPEN_PROFILE":
        const { businessId, page,data} = params.payload;
        setPage(page);
        setData(data);
        loadBusinessProfile(businessId, page);
        break;

      default:
        break;
    }
  }, [params]);

  return (
    <>
    <StatusBar bg="#3700B3" barStyle="light-content" />
      <Center>
        <Box safeAreaTop bg="white" />
        <Box bg="#fff" borderBottomWidth={1} borderBottomColor="#F5A400" w="100%">
            <HStack
                px={6}
                py={4}
                alignItems="center"
                justifyContent="space-between"
            >
                {/* LEFT LOGO */}
                <HStack alignItems="center" space={2}>
                <Image
                    source={require("../../../assets/tt_logo.png")}
                    alt="Logo"
                    size={10}
                />
                </HStack>

                {/* CENTER BUSINESS INFO */}
                <Pressable
                  onPress={() => navigation.goBack()}
                  _pressed={{ opacity: 0.6 }}
                >
                <VStack alignItems="center" space={1}>
                <Avatar
                    size="sm"
                    source={{
                    uri: data.logo_url ? data.logo_url : "",
                    }}
                    bg={GlobalStyles.colors.blue}
                >
                    {data?.name
                      ? getAvatarChar(data.name)
                      : getAvatarChar("")}
                </Avatar>

                <Text
                    fontSize="md"
                    fontWeight="600"
                    color="#000"
                >
                    {data?.name || ""}
                </Text>
                </VStack>
                </Pressable>
                {/* RIGHT ACTION */}
                <HStack justifyContent="space-between" alignItems="center" px={4}>
                <Button
                  size="sm"
                  bg="#ffc000"
                  mr={2}
                  px={6}
                  onPress={() => navigation.goBack()}
                  // leftIcon={<Icon as={Ionicons} name="arrow-back" size="sm" />}
                >
                  <Text fontWeight="600" color="#fff">Back</Text>
                </Button>
                <Button
                size="sm"
                bg="#0A1B6F"
                borderRadius={4}
                px={6}
                _hover={{ bg: "#0A1B6F" }}
                >
                <Text color="#fff" fontWeight="600">
                    Follow
                </Text>
                </Button>
                </HStack>
            </HStack>
        </Box>
        
        <Divider bg={GlobalStyles.colors.mustard} w="100%" />
      </Center>
      <ScrollView ref={scrollViewRef} onScroll={handleScroll}
        scrollEventThrottle={16}>
        <Center>
          {/* <Box safeAreaTop bg="white" /> */}

          <HStack
            bg="#F5F5F5"
            justifyContent="space-between"
            alignSelf="flex-start"
            w="100%"
            maxW="970"
          >
            {window?.innerWidth >= 415 && (
              <HStack
              bg="#F5F5F5"
              justifyContent="space-between"
              w="100%"
              maxW={[
                user.user_category == GlobalConstants.userCategories.citizen.id
                  ? 75
                  : 0,
                130,
                130,
              ]}
            >
              {user.user_category ==
                GlobalConstants.userCategories.citizen.id && (
                <VStack>
                      <Box
                      // bg="gray.900"
                      color="white"
                      h="100vh"
                      w="250px"
                      position="sticky"
                      left={0}
                      top={2}
                      p={4}
                      boxShadow="lg"
                    >
                        

                      {/* Menu Items */}
                      <VStack spacing={8} >
                        {menuItems.map((item) => (
                          <Box key={item.name} position="relative" w="100%">
                          <Button
                            key={item.name}
                            w="100%"
                            size="sm"
                            variant="solid"
                            mt="3"
                            mx={5}
                            justifyContent="stretch"
                            _hover={{ bg: GlobalStyles.colors.grey }} 
                            // CHANGE 4:highlight active menu item with mustard background
                            //bg={ GlobalStyles.colors.sideButton}
                            bg={activeService === item.action.toString() ? GlobalStyles.colors.mustard : GlobalStyles.colors.sideButton}
                            onPress={() => handlePress(item.name, item.action)}
                            leftIcon={
                              <Image source={item.icon} alt={`${item.name} Icon`} size="7" mr="6" />
                            }
                          >
                            <Text
                              fontSize={"16px"}
                            fontWeight={"500"}
                            fontFamily={GlobalStyles.text.fontFamily}
                            color={GlobalStyles.colors.black}
                            >
                              {item.name}
                            </Text>
                          </Button>
                          </Box>
                        ))}
                      </VStack>
                      </Box>
                </VStack>
              )}
            </HStack>
            )}
            
            <HStack
              bg="#F5F5F5"
              justifyContent="space-between"
              w="100%"
              style={{ display: window?.innerWidth > 450 ? 'block' : 'flex', }}
              maxW={[250, 440, 640]}
            >
              <VStack>
                {/* CHANGE 5:if a service is selected, show that service component instead of the feed */}
                {activeService ? (
                  renderActiveService()
                ): isLoading ? (
                    <Stack w={[300, 450, 610]} alignItems="center">
                      <Spinner
                        color={GlobalStyles.colors.mustard}
                        m={10}
                        size="lg"
                        accessibilityLabel="Loading posts"
                      />
                    </Stack>
                    ) : ticks.length > 0 ? (
                    window?.innerWidth >= 415 ? (
                      <ScrollView w={[260, 360, 610]} showsVerticalScrollIndicator={false}>
                        <VStack alignItems="center">
                          <Stack
                            justifyContent="center"
                            flexDirection="row"
                            space={3}
                            flexWrap="wrap"
                            m={1}
                          >
                            {ticks.map((x, index) => (
                              <FeedCardForCitizen 
                                key={index}
                                data={x}
                                setSelectedPost={onClick}
                                friends={friends}
                              />
                            ))}
                          </Stack>

                          {!isSavedFeeds && !isShareFeeds && showLoadMore && (
                            <Button
                              my={5}
                              isLoading={isLoadMoreLoading}
                              size="sm"
                              variant="outline"
                              onPress={loadMoreFeed}
                            >
                              Load More
                            </Button>
                          )}
                        </VStack>
                      </ScrollView>
                    ) : (
                      <ScrollView
                        style={{ flex: 1 }}
                        w="100%"
                        showsVerticalScrollIndicator={false}
                        contentContainerStyle={{
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        <VStack w="100%" alignItems="center">
                          <Stack
                            justifyContent="center"
                            flexDirection="column"
                            space={3}
                            flexWrap="wrap"
                            mx={3}
                            w="100%"
                            mb="20%"
                          >
                            {ticks.map((x, index) => (
                              <FeedCardForCitizen
                                key={index}
                                data={x}
                                setSelectedPost={onClick}
                                friends={friends}
                              />
                            ))}
                          </Stack>

                          {!isSavedFeeds && !isShareFeeds && showLoadMore && (
                            <Button
                              position="relative"
                              bottom="60px"
                              isLoading={isLoadMoreLoading}
                              size="sm"
                              variant="outline"
                              onPress={loadMoreFeed}
                            >
                              Load More
                            </Button>
                          )}
                        </VStack>
                      </ScrollView>
                    )
                  ) : null}
               
                
                
              </VStack>
            </HStack>
            
            
          </HStack>
        </Center>
      </ScrollView>
      {showUpButton && (<IconButton
        position="absolute"
        bottom={window?.innerWidth > 450 ? 10 : 12}
        right={10}
        borderRadius="full"
        bg={GlobalStyles.colors.blue}
        _pressed={{ bg: "gray.500" }}
        icon={<ChevronUpIcon color="white" size={6} />}
        onPress={scrollToTop}
      />)}
      
      {window?.innerWidth <= 450 &&(
        <VStack
        position="fixed"
        bottom={0}
        left={0}
        right={0}
        bg={GlobalStyles.colors.white}
        py="2"
        borderTopWidth={1}
        borderColor="gray.300"
      >
        <HStack justifyContent="space-between" w="90%" mx="auto">
           {/* CHANGE 6:updated mobile bottom nav actions to also call setActiveService */}
          {[
            { name: "Loyality Points", icon: require("../../../assets/side-bar-icons/loyality.png"), action: () => setActiveService("loyalty")  },
            { name: "Coupons", icon: require("../../../assets/side-bar-icons/coupon_icon.png"), action: () => setActiveService("coupon") },
            { name: "Reservations", icon: require("../../../assets/side-bar-icons/reservation_icon.png"),  action: () => setActiveService("reservation") },
            { name: "Ticketing", icon: require("../../../assets/side-bar-icons/ticket_icon.png"), action: () => setActiveService("ticket") },
            { name: "Survey", icon: require("../../../assets/side-bar-icons/wpf_survey.png"), action: () => setActiveService("survey") }
          ].map((item, index) => (
            <Button
              key={index}
              variant="unstyled"
              _hover={{ bg: GlobalStyles.colors.grey }} 
              onPress={() => handlePress(item.name, item.action)}
            >
              <VStack alignItems="center">
                <Image source={item.icon} alt={`${item.name} Icon`} size="6" />
                {/* {subActiveButton === item.name && (
                  <Box width="20px" height="2px" bg={GlobalStyles.colors.mustard} mt="1" />
                )} */}
              </VStack>
            </Button>
          ))}
        </HStack>
        </VStack>
      )}
      
    </>
  );
};

export default BusinessProfile;